import React from "react";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";

// For Modal
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// End

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// import { useEffect } from "react";
import swal from "sweetalert";

import { makePostRequest } from "../../../utils/utils";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";

import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
import QRCode from "react-qr-code";

const label = { inputProps: { "aria-label": "Size switch demo" } };

function GuardsNewList() {
  const navigate = useNavigate();
  const [selected, setSelected] = React.useState(false);

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);

  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );


  const [guardsList, setGuardsList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [, setlength] = React.useState();
  const [showLoader, setShowLoader] = React.useState(false);
  const [isActive, setIsActive] = React.useState();
  const [sortBy, setSortBy] = React.useState("");

  // For Modal
  const [open2, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const [societyName, setSocietyName] = React.useState("");
  const [guardName, setGuardName] = React.useState("");
  const [guardContactNo, setGuardContactNo] = React.useState("");
  const [guardProfilePic, setGuardProfilePic] = React.useState("");
  const [Upload, setUpload] = React.useState(false);
  const [guardId, setguardId] = React.useState();
  const [, setChecked] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  async function handleChangeSortBy() {
    alert(sortBy);
    if (sortBy === "") setSortBy("ASC");
    else if (sortBy === "DESC") setSortBy("ASC");
    else if (sortBy === "ASC") setSortBy("DESC");
    setUpload(!Upload);
    GuardsListing();
  }

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  async function GuardsListing() {
    let bodyFormData = {
      searchq: q,
      status: isActive,
      sortBy: sortBy,
      pageNo: currentPage,
      count: itemsPerPage,
    };
    setShowLoader(true);
    await makePostRequest("guards/guardlisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Guards Data");
          console.log(response.data.data.rows);
          setlength(response.data.data.rowCount);
          const data = response.data.data.data;
          setGuardsList(data);
          setTotalItems(response.data.data.total_records);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  }

  // async function handleChangeFilter(status) {
  //   setIsActive(status);
  //   GuardsListing();
  // }
  // For memu

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    setShowLoader(true);
    let st = e.currentTarget.dataset.myValue;
    setIsActive(st);
    setUpload(!Upload);
    setShowLoader(false);

    GuardsListing();
    setAnchorEl(null);
  };
  // End



  const handleClickOpen2 =
    (scrollType, guard_profile_pic, guard_name, contact_no, data) => () => {
      setOpen(true);
      setScroll(scrollType);
      setGuardProfilePic(guard_profile_pic);
      setGuardName(guard_name);
      setGuardContactNo(contact_no);
      setSocietyName(localStorage.getItem("societyName"));
      setguardId(data.guard_id);
    };

  const handleClose2 = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    localStorage.removeItem("residentid");
    GuardsListing();
  }, [open2, q, Upload, currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };



  const handleChange = (event, guardObj) => {
    setChecked(event.target.checked);
    setShowLoader(true);
    let inputdata = {
      guard_id: guardObj.guard_id,
      status: event.target.checked,
    };

    makePostRequest("guards/update/web", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          // window.location.reload();
          GuardsListing();
        }

        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  };

  // delete recident
  // async function deleteGuard(id) {
  //   const willDelete = await swal({
  //     title: "Are you sure?",
  //     text: "Do you really want to delete this record? This process cannot be undone.",
  //     icon: "warning",
  //     buttons: ["No", "Yes"],
  //   });

  //   if (willDelete) {
  //     var bodyFormData = new FormData();
  //     makeGetRequest("guards/delete/" + id, bodyFormData)
  //       .then((response) => {
  //         if (response.data.status === "1") {
  //           swal("Success", "Record deleted successfully", "success", {
  //             timer: 1000,
  //             buttons: false,
  //           });
  //           GuardsListing();
  //         } else {
  //           swal("Error", "Failed to delete", "error");
  //         }
  //       })
  //       .catch((err) => {
  //         swal("There was an error!", "more error details", "warning");
  //         console.log("Invalid username password!!", err);
  //       });
  //   }
  // }

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorHead">Guard List</div>
              <div className="visitorListNewInner">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input
                      type="text"
                      placeholder="Search"
                      onChangeCapture={(e) => setQ(e.target.value)}
                    />
                    {/* <MicIcon className="visitorMicIco" /> */}
                  </div>
                  <div>
                    <SortIcon
                      className="visitorFilterIco"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem data-my-value={true} onClick={handleClose}>
                        Active
                      </MenuItem>
                      <MenuItem data-my-value={false} onClick={handleClose}>
                        De-Active
                      </MenuItem>
                    </Menu>
                  </div>

                  <div className="sortingIcoOut">
                    {/* Statics */}
                    <ToggleButton
                      value="check"
                      selected={selected}
                      onChange={() => {
                        setSelected(!selected);
                      }}
                    >
                      <ImportExportIcon
                        className="visitorFilterIco"
                        aria-controls={open}
                        aria-haspopup="true"
                        aria-expanded={open}
                        onClick={handleChangeSortBy}
                      />
                    </ToggleButton>
                  </div>
                </div>

                {guardsList.map((option) => (
                  <div className="visitContDiv" key={option.guard_id}>
                    <div className="visitCont1 resideNewContOut">
                      <div className="visitContProf">
                        <Zoom>
                          {option.guard_profile_pic ? (
                            <img src={option.guard_profile_pic} />
                          ) : (
                            <img src={defaultProfilePic} />
                          )}
                        </Zoom>
                      </div>
                      <div className="visitContLeft">
                        <h3 className="visitContHed">{option.guard_name}</h3>
                        <p className="visitContMob">{option.contact_no}</p>
                        <p className="visitContTime">{option.email_id}</p>
                      </div>
                      <div className="visitBottCont">
                        <p>Guard Identity Code</p>
                        <b>{option.guardidentitycode}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>society Code</p>
                        <b>{option.society_code}</b>
                      </div>
                      <div className="resideNewCont">
                        {localStorage.setItem("guardId", option.guard_id)}
                        <CreateIcon
                          className="editBt"
                          // onClick={handleClickOpen2("body")}
                          onClick={() =>
                            navigate("/EditGuardNew/" + option.guard_id)
                          }
                        />
                        {/* <DeleteIcon
                          className="deleteBt"
                          onClick={() => deleteGuard(option.guard_id)}
                        /> */}
                        <Switch
                          {...label}
                          checked={option.status}
                          size="small"
                          onChange={(event) => handleChange(event, option)}
                        />
                      </div>
                    </div>
                    <div className="visitCont2">
                      <div className="visitBottCont">
                        <p>Address</p>
                        <b>{option.address}</b>
                      </div>
                      <div className="visitBottCont previewButt">
                        <p>Entry Pass</p>

                        <Button
                          className="emtyPassPreview"
                          onClick={handleClickOpen2(
                            "body",
                            option.guard_profile_pic,
                            option.guard_name,
                            option.contact_no,
                            option
                          )}
                        >
                          Preview
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
                <Grid container spacing={3} >
                  <Grid item xs={12} md={12} >
                    <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                      page={currentPage}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded" />
                  </Grid>
                </Grid>
                {/* <div className="listPaginationMain">
                  <Stack spacing={2}>
                    <Pagination count={10} variant="outlined" shape="rounded" />
                  </Stack>
                </div> */}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Entry Pass Preview</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="entryPassMain entryPassMain2">
                      <div className="entryPassInner">
                        <h4 className="entryParkHeading">{societyName}</h4>
                        <div className="entryPassPro">
                          <Zoom>
                            {guardProfilePic ? (
                              <img src={guardProfilePic} />
                            ) : (
                              <img src={defaultProfilePic} />
                            )}
                          </Zoom>
                        </div>
                        <div>
                          {/* <Button className="serviceNameBt">Maid</Button> */}
                        </div>
                        <div className="entryPassNameNum">
                          <p>{guardName}</p>
                          <span>{guardContactNo}</span>
                        </div>
                        <div className="entryPassBott">
                          <div className="emtyPssBarOut">
                            {/* <Zoom>
                              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/QR_Code_Example.svg/1024px-QR_Code_Example.svg.png" />
                            </Zoom> */}
                            <Zoom>
                              <div style={{ height: "auto", margin: "0 auto", maxWidth: 64, width: "100%" }}>
                                <QRCode
                                  size={256}
                                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                  value={JSON.stringify({ id: guardId, contact: guardContactNo, guard_name: guardName })}
                                  viewBox={`0 0 256 256`}
                                />
                              </div></Zoom>
                          </div>
                          <p>Powered by Resipro</p>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      {/* <Button className="modalMainBt" onClick={addCommitee}>
                        Download
                      </Button> */}
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>Successfully Downloaded</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default GuardsNewList;
